import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToTime'
})
export class SecondsToTimePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    let time = Number(value);
    if (time){
      if (time < 60){

        return Math.round(Math.ceil(time)) + "s";
      }
      else if(time >= 60 && time < 3600){
        return Math.floor(time / 60) + "m " + Math.ceil((time % 60)) + "s";
      }
      else if(time >= 3600){
        return Math.floor(time / 3600) + "h " + Math.floor((time % 3600) / 60) + "m " +Math.ceil((time % 60))  + "s";
      }
    }
    return null;
  }

}
